import { Routes, Route, Navigate } from 'react-router-dom'
import { ProtectedRoute } from './components/layout/ProtectedRoute'
import { Sidebar } from './components/layout/Sidebar'
import Login from './pages/Login'
import Register from './pages/Register'
import Acceder from './pages/Acceder'
import Pricing from './pages/Pricing'
import Onboarding from './pages/Onboarding'
import Dashboard from './pages/Dashboard'
import Clientes from './pages/Clientes'
import ClienteDetalle from './pages/ClienteDetalle'
import Scraping from './pages/Scraping'
import BillingSettings from './pages/BillingSettings'
import FlowCallback from './pages/FlowCallback'
import { useSchedulerJobs } from './hooks/useScraping'

function AppLayout() {
  const { data: schedulerData } = useSchedulerJobs()
  const activeJobs = schedulerData?.jobs?.length ?? 0
  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <Sidebar activeJobs={activeJobs} />
      <main style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'auto', minWidth: 0 }}>
        <Routes>
          <Route path="/"                    element={<Dashboard />} />
          <Route path="/clientes"            element={<Clientes />} />
          <Route path="/clientes/:id"        element={<ClienteDetalle />} />
          <Route path="/scraping/:clienteId" element={<Scraping />} />
          <Route path="/settings/billing"    element={<BillingSettings />} />
          <Route path="*"                    element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  )
}

export default function App() {
  return (
    <Routes>
      <Route path="/login"      element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/acceder" element={<Acceder />} />
      <Route path="/pricing"    element={<Pricing />} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="/billing/flow-callback" element={<FlowCallback />} />
      <Route path="/*" element={
        <ProtectedRoute>
          <AppLayout />
        </ProtectedRoute>
      } />
    </Routes>
  )
}
